var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as LogRocket from 'logrocket';
import { omit } from 'lodash';
var timerResetDelay = 86400000;
function identify(id, userTraits) {
    LogRocket.identify(id, userTraits);
    console.debug("\uD83D\uDCD6 Remote logger ID set as " + id);
}
function isEnabled() {
    var url = new URL(window.location.href);
    return url.searchParams.get('log') === 'true';
}
function reloadWithLogs() {
    var url = new URL(window.location.href);
    url.searchParams.set('log', 'true');
    window.location.assign(url.href);
}
function reloadWithoutLogs() {
    var url = new URL(window.location.href);
    url.searchParams.delete('log');
    window.location.assign(url.href);
}
function listenForKeyboardShortcut() {
    document.addEventListener('keydown', function (e) {
        if (e.ctrlKey && e.shiftKey && e.code === "KeyS") {
            return isEnabled() ? reloadWithoutLogs() : reloadWithLogs();
        }
    }, false);
}
function initialize(appId, version) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve) {
                    console.debug("\uD83D\uDCD6 Starting remote logger...");
                    LogRocket.init(appId, {
                        release: version,
                        network: {
                            requestSanitizer: function (request) {
                                if (request.method === 'HEAD')
                                    return null;
                                return request;
                            },
                        },
                    });
                    setTimeout(function () { return reloadWithoutLogs(); }, timerResetDelay);
                    LogRocket.getSessionURL(function (url) {
                        console.debug("\uD83D\uDCD6 Remote logger started at " + url);
                        resolve(url);
                    });
                })];
        });
    });
}
function sessionUrl() {
    return LogRocket.sessionURL;
}
function getMiddleware(stateFilter, actionFilter) {
    if (stateFilter === void 0) { stateFilter = []; }
    if (actionFilter === void 0) { actionFilter = []; }
    return LogRocket.reduxMiddleware({
        stateSanitizer: function (state) { return omit(state, stateFilter); },
        actionSanitizer: function (action) { return actionFilter.includes(action.type) ? null : action; }
    });
}
export default {
    getMiddleware: getMiddleware,
    identify: identify,
    initialize: initialize,
    isEnabled: isEnabled,
    reloadWithLogs: reloadWithLogs,
    reloadWithoutLogs: reloadWithoutLogs,
    sessionUrl: sessionUrl,
    listenForKeyboardShortcut: listenForKeyboardShortcut
};
//# sourceMappingURL=Logger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/web-clients-core/dist/es5-module/Logger.js
// module id = 237
// module chunks = 0